/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 4;
export const WallType = new EnumReflection('WallType', {
    enum: [
        'A',
        'B',
        'C'
    ]
});
export const WallDirection = new EnumReflection('WallDirection', {
    enum: [
        'left',
        'right'
    ]
});
export const CornerFillerType = new EnumReflection('CornerFillerType', {
    enum: [
        'AB',
        'BC'
    ]
});
export const Handing = new EnumReflection('Handing', {
    enum: [
        'left',
        'right',
        'top',
        'both',
        'none'
    ]
});
export const RoomShapeType = new EnumReflection('RoomShapeType', {
    enum: [
        'L',
        'U',
        'I'
    ]
});
export const CabinetColor = new EnumReflection('CabinetColor', {
    type: 'string',
    enum: [
        'Obsidian',
        'Glacier',
        'PacificBlue',
        'CaliforniaPoppy',
        'Surf',
        'DesertSage',
        'Limestone',
        'Sierra'
    ]
});
export const FuelType = new EnumReflection('FuelType', {
    type: 'string',
    enum: [
        'None',
        'Propane',
        'NaturalGas'
    ]
});
export const GrillBaseVariant = new EnumReflection('GrillBaseVariant', {
    type: 'string',
    enum: [
        'Default',
        'WithWarmingDrawer'
    ]
});
export const LynxProfessionalGrillVariant = new EnumReflection('LynxProfessionalGrillVariant', {
    type: 'string',
    enum: [
        'AllCeramic',
        'AllTrident',
        'TridentAndCeramic'
    ]
});
export const LynxSedonaGrillVariant = new EnumReflection('LynxSedonaGrillVariant', {
    type: 'string',
    enum: [
        'ProSear_SsBurner1',
        'ProSear_SsBurner1_Rotisserie',
        'SsBurner3',
        'ProSear_SsBurner2',
        'SsBurner3_Rotisserie',
        'ProSear_SsBurner2_Rotisserie'
    ]
});
export const PowderCoatType = new EnumReflection('PowderCoatType', {
    type: 'string',
    enum: [
        'Anvil',
        'Swatch',
        'Pulse'
    ]
});
export const WallSummaryItem = new AjvReflection('WallSummaryItem', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        sku: {
            type: 'string'
        },
        price: {
            type: 'number'
        },
        thumbnailUrl: {
            type: 'string'
        }
    },
    required: [
        'id',
        'name',
        'sku',
        'price'
    ],
    additionalProperties: false
});
export const WallSummary = new AjvReflection('WallSummary', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        cabinets: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        parts: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        appliances: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        }
    },
    required: [
        'id',
        'name',
        'cabinets',
        'parts',
        'appliances'
    ]
});
export const Summary = new AjvReflection('Summary', {
    type: 'object',
    properties: {
        walls: {
            type: 'array',
            items: WallSummary._meta.schema
        },
        powderCoating: {
            type: 'object',
            properties: {
                name: {
                    type: 'string'
                },
                upChange: {
                    type: 'number'
                },
                price: {
                    type: 'number'
                }
            },
            required: [
                'name',
                'upChange',
                'price'
            ],
            additionalProperties: false
        },
        totalPrice: {
            type: 'number'
        }
    },
    required: [
        'walls',
        'powderCoating',
        'totalPrice'
    ],
    additionalProperties: false
});
const AdjustableDoorCabinetShape = new AjvReflection('AdjustableDoorCabinetShape', {
    type: 'object',
    properties: {
        handing: Handing._meta.schema
    },
    additionalProperties: false,
    required: [
        'handing'
    ]
});
const RearPanelShape = new AjvReflection('RearPanelShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762,
                914.4,
                1066.8,
                1219.2,
                1371.6,
                1524,
                1676.4,
                1828.8,
                1981.2,
                2133.6,
                2286,
                2438.4
            ]
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'width'
    ]
});
const BottomCabinetWithApplianceShape = new AjvReflection('BottomCabinetWithApplianceShape', {
    type: 'object',
    properties: {
        applianceId: {
            anyOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'applianceId'
    ]
});
const WallItemShape = new AjvReflection('WallItemShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        x: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'x'
    ]
});
const Drawer33Door66Shape = new AjvReflection('Drawer33Door66Shape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const EndPanelShape = new AjvReflection('EndPanelShape', {
    type: 'object',
    properties: {
        depth: {
            type: 'number',
            enum: [
                717.55,
                742.95
            ]
        }
    },
    additionalProperties: false,
    required: [
        'depth'
    ]
});
const FillerShape = new AjvReflection('FillerShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                25.4,
                31.75,
                38.1,
                44.45,
                50.8,
                57.15,
                63.5,
                69.85,
                76.2,
                82.55,
                88.9,
                95.25,
                101.6,
                107.95,
                114.3,
                120.65,
                127
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const FullDoorBaseShape = new AjvReflection('FullDoorBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                304.8,
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const GrillBaseShape = new AjvReflection('GrillBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                914.4,
                1066.8,
                1219.2,
                1524
            ]
        },
        variant: GrillBaseVariant._meta.schema
    },
    additionalProperties: false,
    required: [
        'width',
        'variant'
    ]
});
const LynxProfessionalGrillW30Shape = new AjvReflection('LynxProfessionalGrillW30Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW36Shape = new AjvReflection('LynxProfessionalGrillW36Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW42Shape = new AjvReflection('LynxProfessionalGrillW42Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW54Shape = new AjvReflection('LynxProfessionalGrillW54Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW30Shape = new AjvReflection('LynxSedonaGrillW30Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW36Shape = new AjvReflection('LynxSedonaGrillW36Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW42Shape = new AjvReflection('LynxSedonaGrillW42Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSinkShape = new AjvReflection('LynxSinkShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const RoomShape = new AjvReflection('RoomShape', {
    type: 'object',
    properties: {
        shape: RoomShapeType._meta.schema,
        powderCoatType: PowderCoatType._meta.schema,
        cabinetColor: CabinetColor._meta.schema,
        fuelType: FuelType._meta.schema,
        stainlessSafeEnvironment: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'shape',
        'powderCoatType',
        'cabinetColor',
        'fuelType',
        'stainlessSafeEnvironment'
    ]
});
const SinkBaseShape = new AjvReflection('SinkBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                609.6,
                762,
                914.4,
                1219.2
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const ThreeDrawerBaseShape = new AjvReflection('ThreeDrawerBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const TrashPulloutBaseShape = new AjvReflection('TrashPulloutBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const WallShape = new AjvReflection('WallShape', {
    type: 'object',
    properties: {
        wallType: WallType._meta.schema,
        length: {
            type: 'number'
        },
        fullHeight: {
            type: 'boolean'
        },
        hidden: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'wallType',
        'length',
        'fullHeight',
        'hidden'
    ]
});
const CornerFillerShape = new AjvReflection('CornerFillerShape', {
    type: 'object',
    properties: {
        cornerFillerType: CornerFillerType._meta.schema
    },
    additionalProperties: false,
    required: [
        'cornerFillerType'
    ]
});
export const BurnerBaseW18 = new DomainEntityReflection('BurnerBaseW18', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const BurnerBaseW24 = new DomainEntityReflection('BurnerBaseW24', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const CornerFiller = new DomainEntityReflection('CornerFiller', [
    CornerFillerShape._meta.schema
]);
export const Drawer33Door66 = new DomainEntityReflection('Drawer33Door66', [
    Drawer33Door66Shape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoBaseW36 = new DomainEntityReflection('EvoBaseW36', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoAffinity25G = new DomainEntityReflection('EvoAffinity25G', []);
export const EvoAffinity30G = new DomainEntityReflection('EvoAffinity30G', []);
export const EndPanel = new DomainEntityReflection('EndPanel', [
    EndPanelShape._meta.schema,
    WallItemShape._meta.schema
]);
export const Filler = new DomainEntityReflection('Filler', [
    FillerShape._meta.schema,
    WallItemShape._meta.schema
]);
export const FullDoorBase = new DomainEntityReflection('FullDoorBase', [
    FullDoorBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const GrillBase = new DomainEntityReflection('GrillBase', [
    GrillBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const KamadoGrillBase = new DomainEntityReflection('KamadoGrillBase', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxAsadoGriddgle = new DomainEntityReflection('LynxAsadoGriddgle', []);
export const LynxKamadoGrill = new DomainEntityReflection('LynxKamadoGrill', []);
export const LynxProfessionalCocktailStation = new DomainEntityReflection('LynxProfessionalCocktailStation', []);
export const LynxProfessionalGrillW30 = new DomainEntityReflection('LynxProfessionalGrillW30', [
    LynxProfessionalGrillW30Shape._meta.schema
]);
export const LynxProfessionalGrillW36 = new DomainEntityReflection('LynxProfessionalGrillW36', [
    LynxProfessionalGrillW36Shape._meta.schema
]);
export const LynxProfessionalGrillW42 = new DomainEntityReflection('LynxProfessionalGrillW42', [
    LynxProfessionalGrillW42Shape._meta.schema
]);
export const LynxProfessionalGrillW54 = new DomainEntityReflection('LynxProfessionalGrillW54', [
    LynxProfessionalGrillW54Shape._meta.schema
]);
export const LynxProfessionalSingleBurner = new DomainEntityReflection('LynxProfessionalSingleBurner', []);
export const LynxProfessionalDoubleBurner = new DomainEntityReflection('LynxProfessionalDoubleBurner', []);
export const LynxProfessionalPowerBurner = new DomainEntityReflection('LynxProfessionalPowerBurner', []);
export const LynxSedonaGrillW30 = new DomainEntityReflection('LynxSedonaGrillW30', [
    LynxSedonaGrillW30Shape._meta.schema
]);
export const LynxSedonaGrillW36 = new DomainEntityReflection('LynxSedonaGrillW36', [
    LynxSedonaGrillW36Shape._meta.schema
]);
export const LynxSedonaGrillW42 = new DomainEntityReflection('LynxSedonaGrillW42', [
    LynxSedonaGrillW42Shape._meta.schema
]);
export const LynxSedonaSingleBurner = new DomainEntityReflection('LynxSedonaSingleBurner', []);
export const LynxSedonaDoubleBurner = new DomainEntityReflection('LynxSedonaDoubleBurner', []);
export const LynxSedonaHoodW36 = new DomainEntityReflection('LynxSedonaHoodW36', [
    WallItemShape._meta.schema
]);
export const LynxSedonaHoodW42 = new DomainEntityReflection('LynxSedonaHoodW42', [
    WallItemShape._meta.schema
]);
export const LynxSedonaHoodW48 = new DomainEntityReflection('LynxSedonaHoodW48', [
    WallItemShape._meta.schema
]);
export const LynxSinkW18 = new DomainEntityReflection('LynxSinkW18', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW24 = new DomainEntityReflection('LynxSinkW24', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW30 = new DomainEntityReflection('LynxSinkW30', [
    LynxSinkShape._meta.schema
]);
export const Room = new DomainEntityReflection('Room', [
    RoomShape._meta.schema
]);
export const RearPanel = new DomainEntityReflection('RearPanel', [
    RearPanelShape._meta.schema
]);
export const SinkBase = new DomainEntityReflection('SinkBase', [
    SinkBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const ThreeDrawerBase = new DomainEntityReflection('ThreeDrawerBase', [
    ThreeDrawerBaseShape._meta.schema,
    WallItemShape._meta.schema
]);
export const TrashPulloutBase = new DomainEntityReflection('TrashPulloutBase', [
    TrashPulloutBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const Wall = new DomainEntityReflection('Wall', [
    WallShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Room
]);
export const StaticEntity = new RawAliasReflection('StaticEntity', [
    Room,
    Wall,
    CornerFiller
]);
export const AdjustableDoorCabinet = new RawAliasReflection('AdjustableDoorCabinet', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
    TrashPulloutBase
]);
export const BottomAppliance = new RawAliasReflection('BottomAppliance', [
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxProfessionalCocktailStation,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    EvoAffinity25G,
    EvoAffinity30G
]);
export const TopAppliance = new RawAliasReflection('TopAppliance', [
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48
]);
export const BurnerBase = new RawAliasReflection('BurnerBase', [
    BurnerBaseW18,
    BurnerBaseW24
]);
export const LynxSink = new RawAliasReflection('LynxSink', [
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30
]);
export const BottomCabinet = new RawAliasReflection('BottomCabinet', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomCabinetWithAppliance = new RawAliasReflection('BottomCabinetWithAppliance', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
    KamadoGrillBase,
    SinkBase
]);
export const BottomCabinetWithoutAppliance = new RawAliasReflection('BottomCabinetWithoutAppliance', [
    Drawer33Door66,
    FullDoorBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomCabinetWithDefaultDetail = new RawAliasReflection('BottomCabinetWithDefaultDetail', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    Drawer33Door66,
    FullDoorBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomPart = new RawAliasReflection('BottomPart', [
    EndPanel,
    Filler,
    RearPanel
]);
export const BottomWallItemWithDefaultCountertop = new RawAliasReflection('BottomWallItemWithDefaultCountertop', [
    Drawer33Door66,
    EndPanel,
    Filler,
    FullDoorBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomWallItemWithCustomCountertop = new RawAliasReflection('BottomWallItemWithCustomCountertop', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
    KamadoGrillBase,
    SinkBase
]);
export const BottomWallItemWithDefaultToeKick = new RawAliasReflection('BottomWallItemWithDefaultToeKick', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    Filler,
    FullDoorBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomWallItemWithCustomToeKick = new RawAliasReflection('BottomWallItemWithCustomToeKick', [
    GrillBase
]);
export const BottomWallItemWithBackPanel = new RawAliasReflection('BottomWallItemWithBackPanel', [
    ...BottomCabinet.reflections,
    Filler,
    EndPanel
]);
export const RoomItem = new RawAliasReflection('RoomItem', [
    ...BottomAppliance.reflections,
    ...BottomCabinet.reflections,
    ...BottomPart.reflections,
    ...TopAppliance.reflections
]);
export const BottomWallItem = new RawAliasReflection('BottomWallItem', [
    ...BottomCabinet.reflections,
    Filler,
    EndPanel
]);
export const TopWallItem = new RawAliasReflection('TopWallItem', [
    ...TopAppliance.reflections
]);
export const WallItem = new RawAliasReflection('WallItem', [
    ...BottomWallItem.reflections,
    ...TopWallItem.reflections
]);
export const LynxProfessionalGrill = new RawAliasReflection('LynxProfessionalGrill', [
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54
]);
export const LynxSedonaGrill = new RawAliasReflection('LynxSedonaGrill', [
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42
]);
export const LynxGrill = new RawAliasReflection('LynxGrill', [
    ...LynxProfessionalGrill.reflections,
    ...LynxSedonaGrill.reflections
]);
export const LynxProfessionalBurner = new RawAliasReflection('LynxProfessionalBurner', [
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner
]);
export const LynxSedonaBurner = new RawAliasReflection('LynxSedonaBurner', [
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner
]);
export const LynxBurner = new RawAliasReflection('LynxBurner', [
    ...LynxProfessionalBurner.reflections,
    ...LynxSedonaBurner.reflections
]);
export const ResizableWallItem = new RawAliasReflection('ResizableWallItem', [
    Drawer33Door66,
    GrillBase,
    Filler,
    FullDoorBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const LynxSedonaHood = new RawAliasReflection('LynxSedonaHood', [
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48
]);
export const Hood = new RawAliasReflection('Hood', [
    ...LynxSedonaHood.reflections
]);
export const Appliance = new RawAliasReflection('Appliance', [
    ...TopAppliance.reflections,
    ...BottomAppliance.reflections
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    StaticEntity: StaticEntity.types,
    AdjustableDoorCabinet: AdjustableDoorCabinet.types,
    BottomAppliance: BottomAppliance.types,
    TopAppliance: TopAppliance.types,
    BurnerBase: BurnerBase.types,
    LynxSink: LynxSink.types,
    BottomCabinet: BottomCabinet.types,
    BottomCabinetWithAppliance: BottomCabinetWithAppliance.types,
    BottomCabinetWithoutAppliance: BottomCabinetWithoutAppliance.types,
    BottomCabinetWithDefaultDetail: BottomCabinetWithDefaultDetail.types,
    BottomPart: BottomPart.types,
    BottomWallItemWithDefaultCountertop: BottomWallItemWithDefaultCountertop.types,
    BottomWallItemWithCustomCountertop: BottomWallItemWithCustomCountertop.types,
    BottomWallItemWithDefaultToeKick: BottomWallItemWithDefaultToeKick.types,
    BottomWallItemWithCustomToeKick: BottomWallItemWithCustomToeKick.types,
    BottomWallItemWithBackPanel: BottomWallItemWithBackPanel.types,
    RoomItem: RoomItem.types,
    BottomWallItem: BottomWallItem.types,
    TopWallItem: TopWallItem.types,
    WallItem: WallItem.types,
    LynxProfessionalGrill: LynxProfessionalGrill.types,
    LynxSedonaGrill: LynxSedonaGrill.types,
    LynxGrill: LynxGrill.types,
    LynxProfessionalBurner: LynxProfessionalBurner.types,
    LynxSedonaBurner: LynxSedonaBurner.types,
    LynxBurner: LynxBurner.types,
    ResizableWallItem: ResizableWallItem.types,
    LynxSedonaHood: LynxSedonaHood.types,
    Hood: Hood.types,
    Appliance: Appliance.types
};
export const entities = {
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
};

//# sourceMappingURL=v4.js.map